import { useState } from "react";
import useCompany from "./useCompany";
import useAPI from "./useAPI";

export default function useEvent() {
  const api = useAPI()
  const { activeCompany } = useCompany();
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);

  const getAllEvents = async () => {
    if (!activeCompany?.id) {
      setError("Missing company id");
      return [];
    }
    try {
      const eventsList = await api.getListEvents(activeCompany.id);
      setEvents(eventsList);
      return eventsList;
    } catch (err) {
      setError(err.message);
      return [];
    }
  };

  const loadById = async (eventId) => {
    if (!activeCompany?.id) throw new Error("Missing company id");
    const evt = await api.getEventCompanyId(activeCompany.id, eventId);
    return evt;
  }

  const createEvent = async (payload) => {
    if (!activeCompany?.id) throw new Error("Missing company id");
    const response = await api.createEvent(activeCompany.id, payload);
    // Actualizar el estado local para que el nuevo evento aparezca inmediatamente
    setEvents((prev) => [...prev, response]);
    return response;
  };

  const updateEvent = async (eventId, payload) => {
    if (!activeCompany?.id) throw new Error("Missing company id");
    if (!eventId) throw new Error("Missing event id");
    const response = await api.updateEvent(activeCompany.id, eventId, payload);
    // Actualizar el evento en la lista local
    setEvents((prev) =>
      prev.map((e) => (e.id === eventId ? response : e))
    );
    return response;
  };

  const upsertEvent = async (payload) => {
    if (!activeCompany?.id) throw new Error("Missing company id");
    if (payload?.id) {
      return await updateEvent(payload.id, payload);
    }
    return await createEvent(payload);
  };

  const deleteEvent = async (eventId) => {
    if (!activeCompany?.id || !eventId) return;
    await api.deleteEvent(activeCompany.id, eventId);
    setEvents((prev) =>
        Array.isArray(prev)
            ? prev.filter((e) => (e?.id) !== eventId)
            : []
    );
  };

  async function getMembers() {
    if (!activeCompany?.id) return [];
    const members = await api.getCompanyUsers(activeCompany.id);
    return members;
  }

  const getEventAttendees = async (eventId) => {
    if (!activeCompany?.id || !eventId) return [];
    const attendees = await api.getListAttendees(activeCompany.id, eventId);
    return attendees;
  }

  const sendInvites = async (eventId, attendeeIds = []) => {
    if (!activeCompany?.id || !eventId) return;
    if (!Array.isArray(attendeeIds) || attendeeIds.length === 0) return;
    const results = await Promise.all(
      attendeeIds.map((attendeeId) =>
        api.inviteAttendees(activeCompany.id, eventId, attendeeId)
      )
    );
    return results;
  };

  return { events, error, getAllEvents, loadById, createEvent, updateEvent, upsertEvent, getEventAttendees, sendInvites, deleteEvent , getMembers};
}
